import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { format, parse, differenceInDays, addHours } from 'date-fns';
import { ApiService } from '../services/contratos/contratos.service';
import { Observable, interval } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';




@Component({
    selector: 'interplantas-root',
    templateUrl: './interplantas.component.html',
    styleUrls: ['./interplantas.component.css'],
    template: `
    <progressbar [value]="progressValue" [max]="100">{{ progressValue }}%</progressbar>
  `,
    standalone: false
})
export class InterplantasComponent {
  item: any = {
    ID: '',
    Transportadora: '',
    Plate: '',
    ['Local 1']: '',
    ['Local 2']: '',
    ['Local 3']: '',
    ['Local 4']: '',
    ['Local 5']: '',
    ['Local 6']: '',
    ['Janela 1']: '',
    ['Janela 2']: '',
    ['Janela 3']: '',
    ['Janela 4']: '',
    ['Janela 5']: '',
    ['Janela 6']: '',

  };

  progressValue = 0; // Valor atual da barra de progresso
  maxValue = 0; // Valor máximo da barra de progresso
  showProgressBar = false;
  @ViewChild('downloadLink') downloadLink!: ElementRef<HTMLAnchorElement>;
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  queryControlCenter: string = 'controlCenterDB';
  query: string = 'Operacao_Interplantas_Karrara';
  query2: string = 'veiculos_lab_Karrara'
  queryPositionLots: string = 'positionLOTS'
  query4: string = 'Carriers';
  query3: string = 'Locais_Karrara_Transport';
  queryInterplantas: string = 'dadosInterplantas';
  items$: Observable<any> | undefined;
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  // sortDirection: number = 1;
  dias_terminal: Date = new Date();
  Freetime: number = 0;
  dados: any[] = [];
  contratos: string[] = [];
  posicao: any[] = [];
  freetime: string[] = [];
  tripcost: string[] = [];
  custoViagem: string = "";
  handling: string[] = [];
  manuseio: string = "";
  demurrage: string[] = [];
  estadia: string = "";
  valorFree: string = '';
  liner: string = "";
  vessel: string = "";
  custoestadia: number = 0;
  startDate!: Date;
  endDate: Date = new Date();
  editMode!: boolean[];
  informationMode!: boolean[];
  programacao: any[] = [];
  items: any[] = [];
  DataAtual: Date = new Date();
  subscription: any;
  cellClicked = false;
  carriers!: any[];
  places!: any[];
  janela: string = '';
  janela2: string = '';
  janela3: string = '';
  janela4: string = '';
  janela5: string = '';
  janela6: string = '';
  transportadora!: string[];
  locais!: string[];
  dialogOpen!: boolean;
  isLoading: boolean = true;
  dadosInterplantas!: any[];
  filterColumnDados: string = 'dataPainel';
  filterColumnOperacao: string = 'Janela';
  referenceDate!: string;
  numDays: number = 2;
  programacaoCompleta!: any[];
  posicaoCarros!: any[];
  searchString: string = '';
  itemsControlCenter: any;
  filterColumn: string = 'entrada';
  filterColumnDate: string = 'date';
  numDays5: number = 5;
  veiculosLab!: any[];
  campoTocado: boolean = false;
  filtraData!: string;
  sortedColumn: string | null = null; // Nome da coluna atualmente ordenada
  sortDirection: 'asc' | 'desc' = 'asc'; // Direção da ordenação
  dateFilter: string = '';
  usuarioLogado!: any;
  @ViewChild('dateInput2') dateInput2: any;


  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private autenticacaoService: AutenticacaoService
  ) { }

  async ngOnInit() {
    await this.getUserLogado();
    // await this.getItemsFromControlCenter();
    // await this.getProgramacaoFromDynamoDB();
    await this.getPlacesFromDynamoDB();
    await this.getCarriersFromDynamoDB();
    // await this.getDadoInterplantasFromDynamoDB();
    // setTimeout(async () => {
    // await this.armazenarLatitudeEmItems();
    await this.update();
    this.isLoading = false;
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      // Chame a função que deseja executar a cada 3 minutos aqui
      // await this.getProgramacaoFromDynamoDB();
      // await this.getDadoInterplantasFromDynamoDB();
      // // setTimeout(async () => {
      // await this.armazenarLatitudeEmItems();
      // this.isLoading = false;
      // }, 1500);
      await this.update();
    });
  }


  async getUserLogado() {
    //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // console.log(this.usuarioLogado)
  }

  async update() {
    await this.getItemsFromControlCenter();
    await this.getVeiculosLab();
    await this.getProgramacaoFromDynamoDB();
    await this.getPositionLotsFromDynamoDB();
    await this.armazenarLatitudeEmItems();
    await this.getDadoInterplantasFromDynamoDB();
    // await this.verificaJanelasConcluidas();
    // await this.verificarChegadaScania();
    this.isLoading = false;
  }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    const fileBlob = await fetch(fileUrl).then(response => response.blob());
    const rawData = await this.carregaService.loadFile(fileBlob);
    const inflatedData = this.inflateData(rawData); // Inflar os campos desejados
    this.jsonData = inflatedData;
    this.dataLoaded = true;
    // Chama a função para salvar os dados no API Gateway
  }

  async getItemsFromControlCenter(): Promise<void> {
    // console.log('getItemsFromControlCenter')
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    //console.log(this.referenceDate)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryControlCenter, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.itemsControlCenter = items.map(item => ({ ...item, checked: false }));
            this.itemsControlCenter = this.itemsControlCenter.filter((item: { tipoEntrada: string; }) => item.tipoEntrada == 'Descarregamento')
            this.itemsControlCenter = this.itemsControlCenter.filter((objeto: { fornecedor: string; }) => objeto.fornecedor && objeto.fornecedor.includes('LOTS//V'));

            this.itemsControlCenter.forEach((item: any) => {
              const arrayDividido = item.fornecedor.split("//");
              // Atribui os elementos do array a variáveis separadas
              const primeiroItem = arrayDividido[0];
              const segundoItem = arrayDividido[1];
              const numeroSemV = segundoItem.replace("V", "");
              item.carrier = primeiroItem;
              item.viagem = numeroSemV;
            });
            // console.log(this.itemsControlCenter)
            // this.sortByEntryDateDesc();
            // this.cdr.detectChanges();
            // this.applyFilter(); // Chama this.upDate() após a atribuição de items
            // this.isLoading = false;
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compararDatas(data1: string, data2: string) {
    // console.log(data1)
    // console.log(data2)

    const dataFormatada1 = new Date(data1).toLocaleDateString();
    const dataFormatada2 = new Date(data2).toLocaleDateString();
    // console.log(dataFormatada1)
    // console.log(dataFormatada2)

    return dataFormatada1 === dataFormatada2;
  }

  encontrarCorrespondencias(array1: any[], array2: any[]) {
    const correspondencias = [];
    let datasSaoIguais;
    let passo;
    for (const objeto2 of array2) {
      // Encontrar o objeto correspondente no array2
      for (const objeto1 of array1) {
        // if (objeto1.Plate === objeto2.placaVeiculo) {
        // if (objeto1.viagem < 10) {
        //   objeto1.viagem = '0' + objeto1.viagem
        // } 
        if (objeto1.viagem == objeto2.viagem || ('0' + objeto1.viagem) == objeto2.viagem) {
          // const objeto1Correspondente = array2.find(objeto1 => objeto1.Plate === objeto2.placaVeiculo);
          const objeto1Correspondente = objeto1;
          // Se a placa do veículo existir no segundo array
          if (objeto1Correspondente) {
            // console.log(objeto1Correspondente)

            // console.log(objeto1['Destino 1'])
            // console.log(objeto1['Destino 2'])
            // Verifica se a data de JanelaDestino 1 é igual à data de entrada
            // if (objeto1['Destino 1'] == 'SCANIA SBC') {
            //   passo = 'Passo Destino1';
            datasSaoIguais = this.compararDatas(objeto2['entrada'], objeto1Correspondente.Janela);
            // console.log(datasSaoIguais)
            // } else if (objeto1['Destino 2'] == 'SCANIA SBC') {
            //   passo = 'Passo Destino2';
            //   datasSaoIguais = this.compararDatas(objeto1['JanelaDestino 2'], objeto2Correspondente.entrada);
            // } else {
            //   datasSaoIguais = null
            // }
            if (datasSaoIguais) {
              passo = 'PassoEntrega';
              // console.log('entrou')
              // Se ambas as condições forem verdadeiras, adiciona à lista de correspondências
              // if (datasSaoIguais) {
              correspondencias.push({ objeto2, objeto1: objeto1Correspondente, passo });
              continue;
            }
          }
        }
      }
    }
    return correspondencias;
  }

  compareDates(date1str: string, date2str: string): number {
    // //console.log(date1str)
    // //console.log(date2str)
    date1str = date1str.replace("Z", "");
    const date1 = new Date(date1str);
    const date2 = new Date(date2str);
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    // console.log(date1)
    // console.log(date2)
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2    ATRASADO
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2   NO HORARIO
    } else {
      return 0; // date1 é igual a date2
    }
  }

  sortBy(column: string) {
    if (this.sortedColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }

    this.programacao = this.programacao.sort((a, b) => {
      // Converte os valores para números antes de compará-los
      const valueA = typeof a[column] === 'string' ? parseFloat(a[column]) : a[column];
      const valueB = typeof b[column] === 'string' ? parseFloat(b[column]) : b[column];

      let comparison = 0;
      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }

      return this.sortDirection === 'asc' ? comparison : -comparison;
    });
  }

  sortByRota(column: string) {
    this.programacao = this.programacao.sort((a, b) => {
      if (a.rota < b.rota) return -1;
      if (a.rota > b.rota) return 1;
      if (a.Janela < b.Janela) return -1;
      if (a.Janela > b.Janela) return 1;
      return 0;
    });
  }

  async filtraPelaData() {
    await this.update()
  }

  onFieldTouched() {
    // console.log("tocou")
    this.campoTocado = true;
  }

  editDialog(item: any): void {
    this.campoTocado = false;
    // console.log(item)
    this.item = { ...item }
    if (Array.isArray(this.carriers)) {
      this.transportadora = this.carriers.map(carrier => carrier.name);
    }
    if (Array.isArray(this.places)) {
      this.locais = this.places.map(places => places.local);
    }
    this.item['date'] = item['Janela'];
    this.item.rota = item.rota ? item.rota : 'Z';
    this.dialogOpen = true;
  }

  async salvar2(item: any) {
    this.item = { ...item };
    this.item['Transport Type'] = await this.veiculosLab.find(item => item.placa.replace(/\s/g, '') === this.item.Plate.replace(/\s/g, ''))?.modelo;
    // this.item['Transport Type'] = await this.veiculosLab.find(item => item.placa === this.item.Plate)?.modelo;
    // this.item['Transport Type'] = item['Transport Type'];
    if (this.item['Weight Loaded'] && this.item['Total Distance']) {
      if (this.item['Transport Type']) {
        this.item.Plate = item.Plate;
        this.item.Transportadora = item.Transportadora;
        this.item.veiculoPerfil = item.veiculoPerfil;
        this.item.combustivel = await this.veiculosLab.find(veiculo => veiculo.modelo == this.item['Transport Type']).combustivel;
        this.item.emissao = await this.veiculosLab.find(veiculo => veiculo.modelo == this.item['Transport Type']).emissoes;
        this.item.consumo = await this.veiculosLab.find(veiculo => veiculo.modelo == this.item['Transport Type']).consumo;
        this.item.capacidadeVolumetrica = await this.veiculosLab.find(veiculo => veiculo.modelo == this.item['Transport Type']).volume;
        this.item.capacidadePeso = await this.veiculosLab.find(veiculo => veiculo.modelo == this.item['Transport Type']).peso;
        this.item.VIN = await this.veiculosLab.find(veiculo => veiculo.modelo == this.item['Transport Type']).vincode;
        this.item.emissaoTotal = (item['Total Distance'] * this.item.emissao) / this.item.consumo;
        this.dialogOpen = false;
        this.isLoading = true;
        if (this.item.ID === undefined) {
          const currentDate = new Date();
          const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
          this.item.ID = formattedDate.toString();
          this.item.inseridoManual = true;
        }
        let janelaStr = item.Janela.toString();
        janelaStr = janelaStr.replace("Z", "");
        let janelaDate = new Date(janelaStr);
        janelaDate.setHours(janelaDate.getHours() - 3)
        this.item['Janela'] = new Date(janelaDate);
        this.item['date'] = new Date(janelaDate);
        // this.item['Weight Loaded'] = item['Weight Loaded'];
        // this.item['Total Distance'] = item['Total Distance'];
        this.item.tableName = this.query;
        // Remover as barras invertidas escapadas
        const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
        const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
        // Converter a string JSON para um objeto JavaScript
        const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
        // Converter o objeto JavaScript de volta para uma string JSON
        const modifiedJsonString = JSON.stringify(jsonObject);
        const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
        // Criar um array contendo o objeto
        const jsonArray = [jsonObject2];
        // console.log(jsonArray)
        await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
          await this.update();
          this.isLoading = false;
        }, error => {
          console.log(error);
        });
      } else {
        const confirmacao = window.confirm("A placa inseririda, não esta cadastrada !");
        // Verifica se o usuário confirmou a ação
        if (confirmacao) {
        }
      }
    } else {
      const confirmacao = window.confirm("Os campos marcados como Required, são obrigatórios !!!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
      }
    }
  }


  cancel(): void {
    this.dialogOpen = false;
  }

  async getPlacesFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query3, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.places = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query4, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getDadoInterplantasFromDynamoDB(): Promise<void> {
    // //console.log('Entrou no get dados')
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    const filtro = 'All';
    (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, filtro, this.filterColumnDados, this.referenceDate, this.numDays)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.dadosInterplantas = items.map(item => ({ ...item, checked: false }));
              // //console.log(this.dadosInterplantas)
              // //console.log(items)
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  onCellClick() {
    this.cellClicked = true;
  }

  async salvarNoBanco() {
    this.showProgressBar = true;
    // //console.log('Item a ser salvo:', this.jsonData);
    this.progressValue = 0;
    this.maxValue = this.jsonData.length;
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(this.jsonData, batchSize); // Fraciona o jsonData em lotes menores

    for (const batch of batches) {
      // Acrescentar o campo "lastupdate" com o valor da data de hoje
      const currentDate = new Date();
      const formattedDate = currentDate.getDate().toString().padStart(2, '0') +
        (currentDate.getMonth() + 1).toString().padStart(2, '0') +
        currentDate.getFullYear().toString();
      for (const item of batch) {
        item.lastupdate = formattedDate;
      }
      await this.dynamodbService.salvar(batch, this.query, this.urlAtualiza).subscribe(
        response => {
          this.progressValue = this.progressValue + batch.length;
          // //console.log('Resposta do salvamento:', response);
        },
        error => {
          console.error('Erro ao salvar:', error);
        }
      );
    }
    setTimeout(() => {
      this.showProgressBar = false;
    }, 7000); // Defina o tempo adequado conforme necessário
  }

  toggleEditMode(index: number): void {
    this.editMode[index] = !this.editMode[index];
  }
  toggleInformationMode(index: number): void {
    this.informationMode[index] = !this.informationMode[index];
  }

  acaoDeClique(item: any, NomePasso: string, NomeBotao: string, NomeDestino: string) {
    if (item[NomeBotao] === false) {
      // Executa ação 1
      this.editDialog(item[NomeDestino]);
    } else {
      // Executa ação 2
      this.finalizaPasso(NomePasso, item);
    }
  }

  async finalizaPasso(Passo: string, item: any) {
    await this.salvarNoBanco();
    await this.update();
  }



  async getVeiculosLab(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query2, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLab = items
              .map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Filtra os itens com chave 'DataBordo' indefinida
            // console.log(this.veiculosLab)

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getPositionLotsFromDynamoDB(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.queryPositionLots, this.urlConsulta, 'All')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.posicaoCarros = items
              .map(item => ({ ...item, checked: false }));
            // console.log(this.posicaoCarros)
            this.posicaoCarros.some(position => {
              const vin = position.VIN;
              const matchingVeic = this.veiculosLab.find(obj => obj['vincode'] == vin);
              if (matchingVeic) {
                // console.log(matchingVeic)
                // position['placa'] = matchingVeic['placa'];
                position['modelo'] = matchingVeic['modelo'];
                return false; // Retorna false para continuar iterando
              } else {
                return true; // Retorna true para sair do loop
              }
            });

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  //   convertDateToFormattedDate(date: Date) {
  //     date.setHours(0, 0, 0, 0); // Ajusta as horas para 00:00:00.000
  //     const options = { 
  //         year: 'numeric' as const, 
  //         month: '2-digit' as const, 
  //         day: '2-digit' as const, 
  //         hour: '2-digit' as const, 
  //         minute: '2-digit' as const 
  //     };
  //     return date.toLocaleString('pt-BR', options);
  // }

  convertDateToFormattedDate(date: Date): string {
    date.setHours(8, 51, 0, 0); // Ajusta as horas para 08:51:00.000
    const options = {
      year: 'numeric' as const,
      month: '2-digit' as const,
      day: '2-digit' as const,
      hour: '2-digit' as const,
      minute: '2-digit' as const
    };
    return date.toLocaleString('pt-BR', options).replace(',', ''); // Remove a vírgula extra
  }

  async getProgramacaoFromDynamoDB(): Promise<void> {
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    // console.log(this.referenceDate)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumnDate, this.referenceDate, this.numDays5)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.programacaoCompleta = items

            // this.programacaoCompleta = items.filter(item => {
            //   const itemDate = new Date(item['Janela']);
            //   const todayDate = new Date();
            //   // Função para comparar apenas as datas (ignorando as horas)
            //   const isSameDate = (date1: Date, date2: Date) => {
            //     return (
            //       date1.getFullYear() === date2.getFullYear() &&
            //       date1.getMonth() === date2.getMonth() &&
            //       date1.getDate() === date2.getDate()
            //     );
            //   };
            //   // Compara as duas datas (apenas as datas)
            //   return isSameDate(itemDate, todayDate);
            // });
            // console.log(this.programacaoCompleta)
            this.programacao = this.programacaoCompleta
              .filter(item => item.ViagemCompleta != true && item.ViagemCompleta != "True" && item.ViagemCompleta != "true" && item.viagemCancelada != true)
            // .map(item => ({ ...item, checked: false }));

            // console.log("programação")
            // console.log(this.programacao)
            this.programacao = this.programacao.sort((a, b) => {
              if (a.rota < b.rota) return -1;
              if (a.rota > b.rota) return 1;
              if (a.Janela < b.Janela) return -1;
              if (a.Janela > b.Janela) return 1;
              return 0;
            });
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async armazenarLatitudeEmItems() {
    for (let i = 0; i < this.programacao.length; i++) {
      let dataString = ''
      let formatoString = '';
      let matchingPosicao;
      // let matchingModel;
      const plateIni = this.programacao[i]['Plate'];
      const vin = this.programacao[i]['VIN'];
      // console.log(vin)
      const plate = plateIni?.replace(/[^a-zA-Z0-9]/g, '');
      // console.log(plate)
      if (plate !== '' || plate !== undefined) {
        matchingPosicao = await this.posicaoCarros.find(obj => obj['placa'] == plate);
        if (matchingPosicao) {
          // console.log(matchingPosicao)
          this.programacao[i]['Latitude'] = matchingPosicao['Latitude'];
          this.programacao[i]['Longitude'] = matchingPosicao['Longitude'];
          this.programacao[i]['Endereco'] = matchingPosicao['Endereco'];
          this.programacao[i]['modelo'] = matchingPosicao['modelo'];
          this.programacao[i]['PositionDateTime'] = matchingPosicao['PositionDateTime'];
        }
        if (this.programacao[i].PositionDateTime) {
          // console.log(this.programacao[i]['PositionDateTime'])
          if (this.programacao[i]['PositionDateTime'] === undefined || this.programacao[i]['PositionDateTime'] === '') {
            this.programacao[i]['Conexao'] = false;
          } else {
            this.DataAtual = new Date();
            const outraDataString = this.programacao[i]['PositionDateTime'].replace("Z", "");
            const outraData = new Date(outraDataString);
            // console.log(outraData)
            outraData.setHours(outraData.getHours() + 1); // Modifica a data
            // console.log(outraData)
            // console.log(this.DataAtual)
            if (outraData > this.DataAtual) {
              this.programacao[i]['Conexao'] = true;
            } else {
              this.programacao[i]['Conexao'] = false;
            }
          }
        } else {
          this.programacao[i]['Conexao'] = false;
        }

      } else {
        this.programacao[i]['Conexao'] = false;
      }
      // console.log(this.programacao[i]['Conexao'])
    }
  }

  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async salvarStatus(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja CONFIRMAR esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      // //console.log("entrou status")
      // //console.log(item)
      item.tableName = 'Operacao_Interplantas_Karrara';
      item['PassoEntrega'] = 2;

      // Inicialize contadores
      let countWithMatchingRota = 0;
      let countWithJanelaConcluidaGreaterThanZero = 0;

      const itemsDataString = JSON.stringify([item]); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string

      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };

      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);

      // //console.log(modifiedJsonString);

      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };

      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];

      await this.dynamodbService.salvar(jsonObject2, this.query, this.urlAtualiza).subscribe(async response => {
        // await this.update();
        await this.getDadoInterplantasFromDynamoDB();

        // Itere sobre os itens em this.programacao
        await this.programacao.forEach(itemProg => {
          // console.log(item)
          // console.log(itemProg)
          const datasSaoIguais = this.compararDatas(item.Janela, itemProg.Janela);

          if (itemProg.rota === item.rota && datasSaoIguais) {
            // console.log("atendeu as condiçoes")
            // console.log(datasSaoIguais)
            countWithMatchingRota++; // Incrementa o contador de correspondências de rota
            // console.log(countWithMatchingRota)

            if (itemProg['PassoEntrega'] > 0) {
              countWithJanelaConcluidaGreaterThanZero++; // Incrementa o contador de JanelaConcluida > 0
              // console.log(countWithJanelaConcluidaGreaterThanZero)

            }
          }
        });
        if (countWithMatchingRota <= countWithJanelaConcluidaGreaterThanZero) {
          // console.log("atendeu as condiçoes para finalizar")
          await this.programacao.forEach(async itemProg => {
            const datasSaoIguais2 = this.compararDatas(item.Janela, itemProg.Janela);
            if (itemProg.rota === item.rota && datasSaoIguais2) {
              console.log("entrou no finalizar")
            }
          });
        }
        this.isLoading = false;
      }, error => {
        console.log(error);
      });

    } else {
      // //console.log(item)
    }

  }

  async completeItem(item: any) {
    // //console.log("entrou completa viagem")
    const confirmacao = window.confirm("Tem certeza que deseja FINALIZAR esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      item.tableName = 'Operacao_Interplantas_Karrara';
      item.PassoEntrega = 2
      item.ViagemCompleta = true;

      const itemsDataString = JSON.stringify([item]); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // //console.log(modifiedJsonString);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      await this.dynamodbService.salvar(jsonObject2, this.query, this.urlAtualiza).subscribe(async response => {
        console.log("terminou de salvar")
        await this.verificaRotasCompletas();
        await this.update();
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    }
  }

  async cancelaItem(item: any) {
    // //console.log("entrou completa viagem")
    const confirmacao = window.confirm("Tem certeza que deseja CANCELAR esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      item.tableName = 'Operacao_Interplantas_Karrara';
      item.viagemCancelada = true;
      const itemsDataString = JSON.stringify([item]); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // //console.log(modifiedJsonString);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      await this.dynamodbService.salvar(jsonObject2, this.query, this.urlAtualiza).subscribe(async response => {
        console.log("terminou de salvar")
        await this.verificaRotasCompletas();
        await this.update();
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    }
  }

  async verificaRotasCompletas() {
    // console.log("entrou no verifica")
    const array1 = this.programacao;
    const array2 = this.itemsControlCenter;
    const contagemDeRotas: { [x: string]: { [x: string]: number } } = {};
    const contagemDeItensComPassoEntrega: { [x: string]: { [x: string]: number } } = {};

    // Função para extrair a data sem hora
    const extrairDataSemHora = (data: string): string => {
      const date1str = data.replace("Z", "");
      const dataSemHora = new Date(date1str);
      dataSemHora.setHours(0, 0, 0, 0);
      return dataSemHora.toString();
    };

    // Iterar sobre o array de objetos
    array1.forEach((objeto) => {
      const rota = objeto.rota;
      const dataJanela = extrairDataSemHora(objeto.Janela);

      // Contagem de rotas por dia
      if (!contagemDeRotas[rota]) {
        contagemDeRotas[rota] = {};
      }
      if (contagemDeRotas[rota][dataJanela]) {
        contagemDeRotas[rota][dataJanela]++;
      } else {
        contagemDeRotas[rota][dataJanela] = 1;
      }

      // Contagem de itens com passo de entrega por dia
      const passoEntrega = objeto.PassoEntrega;
      if (passoEntrega > 0) {
        if (!contagemDeItensComPassoEntrega[rota]) {
          contagemDeItensComPassoEntrega[rota] = {};
        }
        if (contagemDeItensComPassoEntrega[rota][dataJanela]) {
          contagemDeItensComPassoEntrega[rota][dataJanela]++;
        } else {
          contagemDeItensComPassoEntrega[rota][dataJanela] = 1;
        }
      }
    });

    const objetosComContagensIguais = [];
    for (const rota in contagemDeRotas) {
      for (const dataJanela in contagemDeRotas[rota]) {
        const contagemTotalDeItens = contagemDeRotas[rota][dataJanela];
        const contagemDeItensComPassoEntregaAtual = contagemDeItensComPassoEntrega[rota]?.[dataJanela] || 0;
        const objetosDaRota = array1.filter(objeto => objeto.rota === rota && extrairDataSemHora(objeto.Janela) === dataJanela);
        if (contagemTotalDeItens === contagemDeItensComPassoEntregaAtual) {
          objetosComContagensIguais.push(...objetosDaRota);
        }
      }
    }

    for (const objetoCorrespondente of objetosComContagensIguais) {
      await this.completeItemAuto(objetoCorrespondente);
    }

  }

  async completeItemAuto(item: any) {
    // console.log("entrou completa item AUTO")
    // console.log(item)
    // this.isLoading = true;
    item.tableName = 'Operacao_Interplantas_Karrara';
    item.ViagemCompleta = true;
    const itemsDataString = JSON.stringify([item]); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    await this.dynamodbService.salvar(jsonObject2, this.query, this.urlAtualiza).subscribe(async response => {
      // await this.update();
      // this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  testarArquivo(arquivo: File): void {
    this.carregaService.testarArquivoCSV(arquivo).then((estaCorreto) => {
      if (estaCorreto) {
        //console.log('O arquivo CSV está correto.');
      } else {
        //console.log('O arquivo CSV está incorreto.');
      }
    }).catch((erro) => {
      console.error('Erro ao testar o arquivo CSV:', erro);
    });
  }

  inflateData(rawData: any[]): any[] {
    let i = 0;
    return rawData.map((item: any) => {

      const hora1 = item[3];
      const janela = this.carregaService.formatHora(item[3], this.startDate);
      // const janela2 = this.carregaService.formatHora(item[5], this.startDate);
      // const janela3 = this.carregaService.formatHora(item[7], this.startDate);
      // const janela4 = this.carregaService.formatHora(item[9], this.startDate);
      // const janela5 = this.carregaService.formatHora(item[11], this.startDate);
      // const janela6 = this.carregaService.formatHora(item[13], this.startDate);

      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss') + i;
      i = i + 1;

      const inflatedItem: any = {
        'tableName': this.query,
        'ID': formattedDate.toString(),
        'Transportadora': item[0],
        'Viagem': item[1],
        'Plate': item[2],
        'Janela': new Date(janela),
        // 'Janela 2': new Date(janela2),
        // 'Janela 3': new Date(janela3),
        // 'Janela 4': new Date(janela4),
        // 'Janela 5': new Date(janela5),
        // 'Janela 6': new Date(janela6),
        'Local': item[4],
        // 'Local 2': item[6],
        // 'Local 3': item[8],
        // 'Local 4': item[10],
        // 'Local 5': item[12],
        // 'Local 6': item[14]
        // Adicione mais campos conforme necessário
      };
      return inflatedItem;
    });

  }

  compareDatesOnly(isoDate: string, customDate: string): boolean {
    // Converter a data ISO 8601 para um objeto Date
    const date1 = new Date(isoDate);
    // Converter a data customizada para um objeto Date
    const [datePart] = customDate.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const date2 = new Date(year, month - 1, day + 1);
    // Remover a hora, minuto, segundo e milissegundo das datas
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);
    // Comparar as datas
    if (date1 < date2) {
      return false;//'A primeira data é anterior à segunda data.';
    } else if (date1 > date2) {
      return false;//'A primeira data é posterior à segunda data.';
    } else {
      return true;//'As datas são iguais.';
    }
  }

  async buscaOutroDia() {
    this.isLoading = true;
    let specificDate = new Date(this.dateFilter);
    this.referenceDate = this.convertDateToFormattedDate(specificDate);
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumnDate, this.referenceDate, 30)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.programacaoCompleta = items
            this.programacao = this.programacaoCompleta;
            this.programacao = await this.programacao.sort((a, b) => {
              if (a.rota < b.rota) return -1;
              if (a.rota > b.rota) return 1;
              if (a.Janela < b.Janela) return -1;
              if (a.Janela > b.Janela) return 1;
              return 0;
            });
        this.isLoading = false;
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async reinicia(){
    this.isLoading = true;
    this.dateInput2.nativeElement.value = '';
    await this.update();
    this.isLoading = false;
  }


  async acertaModelo() {
    this.programacao.forEach(async item => {
      if (item["Transport Type"] === undefined) {
        item['Transport Type'] = this.veiculosLab.find(veic => veic.placa.replace(/\s/g, '') === item.Plate.replace(/\s/g, ''))?.modelo;
        await this.salvarModelo(item);
      }
    })
    await this.update();
    this.isLoading = false;
  }

  async salvarModelo(item: any) {
    this.item = { ...item };
    this.item.Plate = item.Plate.replace(/\\"/g, '');
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
    }, error => {
      console.log(error);
    });
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja EXCLUIR esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
        async response => {
          await this.update();
          this.isLoading = false;
        },
        error => {
        }
      );
    }
  }

  async aplicarFiltro() {
    this.items = this.programacaoCompleta;
    this.programacao = this.items.filter(item => this.filtrarItem(item));
    this.programacao = this.programacao.filter(item => item.ViagemCompleta != true && item.ViagemCompleta != "True" && item.ViagemCompleta != "true" && item.viagemCancelada != true)
    this.programacao = this.programacao.sort((a, b) => {
      if (a.rota < b.rota) return -1;
      if (a.rota > b.rota) return 1;
      if (a.Janela < b.Janela) return -1;
      if (a.Janela > b.Janela) return 1;
      return 0;
    });
    this.programacao.forEach(prog => {
      prog['observacao'] = this.veiculosLab.find(pos => pos.placa === prog.Plate.replace(/[^a-zA-Z0-9]/g, ''))?.observacao
    })
    await this.armazenarLatitudeEmItems();

  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    if (!this.searchString) {
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }
    const lowerCaseFilter = this.searchString.toLowerCase();
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }
    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  }


}
